import styled from 'styled-components'

export const PrintHeader = styled.div`
  display: flex;
  margin-top: 1rem;
`
